import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5a5 5 0 1 0 -4 8","key":"svg-0"}],["path",{"d":"M16 13a5 5 0 1 0 -4 -8","key":"svg-1"}],["path",{"d":"M12 21l0 -16","key":"svg-2"}]]

/**
 * IconZodiacAries
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItem9kaWFjLWFyaWVzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiA1YTUgNSAwIDEgMCAtNCA4IiAvPgogIDxwYXRoIGQ9Ik0xNiAxM2E1IDUgMCAxIDAgLTQgLTgiIC8+CiAgPHBhdGggZD0iTTEyIDIxbDAgLTE2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/zodiac-aries
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZodiacAries = createReactComponent('outline', 'zodiac-aries', 'ZodiacAries', __iconNode);

export default IconZodiacAries;